module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validationRule),
      expression: "validationRule"
    }],
    class: {
      'input form-control': true, 'is-invalid form-control': _vm.errors.has(_vm.inputId)
    },
    attrs: {
      "name": _vm.inputId,
      "id": _vm.inputId
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.inputId)),
      expression: "errors.has(inputId)"
    }],
    staticClass: "help is-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.inputId)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad5181c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/text-input.vue
// module id = 538
// module chunks = 1